// @flow
export { default as Professionals } from './Professionals';
